// import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
// import Loader from '../components/Loader'; 
import Footer from '../components/Footer';
import { footerEn } from '../data/footer';
import { navigationTop, navigationButtom } from '../params';
import { Link } from 'react-router-dom';

// import '../assets/scss/CoreLabsAboutUs.scss';
// import '../assets/scss/Articles.scss';
// import 'bootstrap/dist/css/bootstrap.min.css'; 




const navigationIntern = []

const crumb = [
    // { link: '//', text: 'Home' },
    { link: '//', text: 'Home' },

    { link: '/research/research-training', text: 'Research Training' },
    { link: '/research/citi', text: 'CITI' },
    { link: '/research/citi/coi', text: 'Conflict of Interest (COI) Course' },



]



function Rcr(props) {
    document.title = 'Conflict of Interest (COI) Course'
    const poster = '/uploads/core-labs.png'
    //const src = '/uploads/welcome.mp4'
    const headerData = {
        title: 'Conflict of Interest (COI) Course',
        crumb: crumb,
        navigationButtom: navigationButtom,
        navigationTop: navigationTop,
        applicationLinks: [{ text: 'Apply now', class: 'bordred', link: '/header/applynow' }],
    }



    return (
        <>
            <Navigation
                navigationIntern={navigationIntern}
                {...headerData}
                updateLang={props.updateLang}
            />
            <section className="space-block-60">
                <div className='container'>
                    <div className='row-listing'>
                        <p>The modules cannot be taken individually. Both modules must be completed with an
                            average score of at least 80% to receive the COI Certificate.</p>



                        <div className="filter-container">
                            <table className="views-table full-width table-style-2" style={{ backgroundColor: '#ffffff' }}>

                                <thead>
                                    <tr>

                                        <th className="f-project-title">Course Title</th>
                                        <th className="f-project-lead">Relevance</th>
                                        <th className="f-project-entity">Suggested Integration at HBKU</th>
                                        <th className="f-project-entity">Duration (hrs) </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="even">

                                        <td>Financial Conflicts of
                                            Interest: Overview,
                                            Investigator
                                            Responsibilities, and
                                            COI Rules (COI-Basic)-
                                            (ID 15070)</td>
                                        <td>Provides essential understanding
                                            of financial conflicts of interest,
                                            investigator disclosure
                                            responsibilities, and relevant
                                            regulatory and institutional
                                            requirements, supporting
                                            research integrity and
                                            transparency.</td>
                                        <td>All researchers
                                            prior to initial
                                            IRB/IBC approval
                                            and annual
                                            compliance</td>
                                        <td>50-75 min</td>

                                    </tr>
                                    <tr className="odd">

                                        <td>Institutional
                                            Responsibilities as They
                                            Affect Investigators (COI-
                                            Basic)- (ID 15072)</td>
                                        <td>Clarifies institutional and
                                            investigator roles in identifying,
                                            reviewing, and managing
                                            conflicts of interest, reinforcing
                                            compliance and accountability.</td>
                                        <td>All researchers
                                            prior to initial
                                            IRB/IBC approval
                                            and annual
                                            compliance</td>
                                        <td>50-75 min</td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <h4>Conflict of Interest: Supplemental Modules</h4>
                        <div className="filter-container">
                            <table className="views-table full-width table-style-2" style={{ backgroundColor: '#ffffff' }}>

                                <thead>
                                    <tr>

                                        <th className="f-project-title">Course Title</th>
                                        <th className="f-project-lead">Relevance</th>
                                        <th className="f-project-entity">Suggested Integration at HBKU</th>
                                        <th className="f-project-entity">Duration (hrs) </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="even">
                                        <td >Conflicts of
                                            Commitment
                                            and Conscience
                                            (COI-Basic)</td>
                                        <td>Addresses non-financial
                                            conflicts related to time
                                            commitment, professional
                                            judgment, and ethical
                                            decision-making, particularly
                                            in the context of external
                                            appointments or consulting
                                            activities.</td>
                                        <td>for faculty, postdoctoral
                                            fellows, and researchers with
                                            external professional
                                            engagements. Integrated into
                                            faculty orientation and
                                            periodic research
                                            compliance refresher
                                            training.</td>
                                        <td>50–75 min</td>


                                    </tr>
                                    <tr className="odd">
                                        <td >Institutional
                                            Conflicts of
                                            Interest (COI-
                                            Basic)</td>
                                        <td>Explains conflicts arising at
                                            the institutional level,
                                            including leadership roles,
                                            institutional financial
                                            interests, and sponsor
                                            relationships. Supports governance-level risk
                                            management and oversight.</td>
                                        <td>for research leadership,
                                            deans, IRB members, chairs,
                                            and compliance and
                                            research administration
                                            staff.</td>
                                        <td>50–75 min</td>

                                    </tr>
               
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* <div className="d-flex justify-content-center">
              <Loader />
          </div> */}
                </div>
            </section>
            <Footer {...footerEn} />
        </>
    )
}

export default Rcr;
